export const RESOLUTION_PHONE = 360;
export const RESOLUTION_TABLET = 768;
export const RESOLUTION_DESKTOP_S = 1240;
export const RESOLUTION_DESKTOP_M = 1536;
export const RESOLUTION_DESKTOP_L = 1920;

export const MEDIA_QUERY_BELOW_SUPPORTED = `(max-width:${RESOLUTION_PHONE - 1}px)`;

export const MEDIA_QUERY_MIN_PHONE = `(min-width:${RESOLUTION_PHONE}px)`;
export const MEDIA_QUERY_MIN_TABLET = `(min-width:${RESOLUTION_TABLET}px)`;
export const MEDIA_QUERY_MIN_DESKTOP_S = `(min-width:${RESOLUTION_DESKTOP_S}px)`;
export const MEDIA_QUERY_MIN_DESKTOP_M = `(min-width:${RESOLUTION_DESKTOP_M}px)`;
export const MEDIA_QUERY_MIN_DESKTOP_L = `(min-width:${RESOLUTION_DESKTOP_L}px)`;

export const MEDIA_QUERY_MAX_TABLET = `(max-width:${RESOLUTION_DESKTOP_S - 1}px)`;
export const MEDIA_QUERY_MAX_PHONE = `(max-width:${RESOLUTION_TABLET - 1}px)`;

const MARGINS = [16, 24, 16, 24, 64];

export const CONTAINER_PHONE = RESOLUTION_PHONE - 2 * MARGINS[0];
export const CONTAINER_TABLET = RESOLUTION_TABLET - 2 * MARGINS[1];
export const CONTAINER_DESKTOP_S = RESOLUTION_DESKTOP_S - 2 * MARGINS[2];
export const CONTAINER_DESKTOP_M = RESOLUTION_DESKTOP_M - 2 * MARGINS[3];
export const CONTAINER_DESKTOP_L = RESOLUTION_DESKTOP_L - 2 * MARGINS[4];
